import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { IRound } from 'types/Round';
import {
  filterPublicLobbyRounds,
  isPublicWaitingRound,
} from 'utils/publicLobbyRounds';

interface LobbyState {
  publicWaitingRounds: IRound[];
}

const initialState: LobbyState = {
  publicWaitingRounds: [],
};

export const lobbySlice = createSlice({
  name: 'lobby',
  initialState,
  reducers: {
    setPublicLobbyRounds: (state, action: PayloadAction<IRound[]>) => {
      state.publicWaitingRounds = filterPublicLobbyRounds(action.payload);
    },
    addPublicLobbyRound: (state, action: PayloadAction<IRound>) => {
      const round = action.payload;
      if (!round.roomName || !isPublicWaitingRound(round)) return;
      if (state.publicWaitingRounds.some((r) => r.roomName === round.roomName))
        return;
      state.publicWaitingRounds = [round, ...state.publicWaitingRounds];
    },
    removePublicLobbyRound: (state, action: PayloadAction<string>) => {
      state.publicWaitingRounds = state.publicWaitingRounds.filter(
        (r) => r.roomName !== action.payload,
      );
    },
    upsertPublicLobbyRound: (state, action: PayloadAction<IRound>) => {
      const round = action.payload;
      if (!round.roomName) return;
      state.publicWaitingRounds = state.publicWaitingRounds.filter(
        (r) => r.roomName !== round.roomName,
      );
      if (isPublicWaitingRound(round)) {
        state.publicWaitingRounds = [round, ...state.publicWaitingRounds];
      }
    },
    clearPublicLobbyRounds: (state) => {
      state.publicWaitingRounds = [];
    },
  },
});

export const {
  setPublicLobbyRounds,
  addPublicLobbyRound,
  removePublicLobbyRound,
  upsertPublicLobbyRound,
  clearPublicLobbyRounds,
} = lobbySlice.actions;

export default lobbySlice.reducer;
